// Material Dashboard 2 PRO React layouts
import Estatisticas from "layouts/pages/relatorios/estatisticas";
import Atletas from "./layouts/pages/cadatros/atletas";
import Eventos from "layouts/pages/cadatros/eventos/";
import NewEvento from "layouts/pages/cadatros/eventos/new-evento";
import Organizador from "layouts/pages/cadatros/organizador";
import Patrocinadores from "layouts/pages/cadatros/patrocinadores";
import Financeiro from "layouts/pages/relatorios/financeiro";
import Cupons from "./layouts/pages/cadatros/cupons";

import Messenger from "layouts/pages/messenger";
import Comunicados from "layouts/pages/comunicados";
import OrcamentoServicos from "layouts/pages/orcamento/servicos";
import OrcamentoSolicitacoes from "layouts/pages/orcamento/solicitacoes";
import Inscricoes from "layouts/pages/inscricoes";
import Resultados from "layouts/pages/resultado";
import Modalidades from "layouts/pages/cadatros/modalidades";
import Extratos from "layouts/financeiro/extratos";

// @mui icons
import Icon from "@mui/material/Icon";

import DefinicaoTaxas from "layouts/financeiro/definicaoTaxas";

import LojaAtributos from "layouts/pages/loja/atributos";
import LojaAvaliacoes from "layouts/pages/loja/avaliacoes";
import LojaCategorias from "layouts/pages/loja/categorias";
import LojaMarcas from "layouts/pages/loja/marcas";
import LojaConfig from "layouts/pages/loja/config";
import ConfigMelhorEnvio from "layouts/pages/loja/config/melhorEnvio";
import LojaCupons from "layouts/pages/loja/cupom";
import LojaProdutos from "layouts/pages/loja/produto";
import LojaPedidos from "layouts/pages/loja/pedidos";
import LojaFinanceiro from "layouts/pages/loja/financeiro";
import LojaFinanceiroLancamentosVendasPage from "layouts/pages/loja/financeiro/lancamentos-vendas";
import LojaFinanceiroContasPagarPage from "layouts/pages/loja/financeiro/contas-pagar";
import LojaFinanceiroContasReceberPage from "layouts/pages/loja/financeiro/contas-receber";
import LojaFinanceiroDREGerencialPage from "layouts/pages/loja/financeiro/dre-gerencial";
import LojaFinanceiroExtratoFinanceiroPage from "layouts/pages/loja/financeiro/extrato-financeiro";
import LojaEstoque from "layouts/pages/loja/estoque";
import ControleAcesso from "layouts/pages/configuracoes/controle-acesso";
import LojaFinanceiroContasFinanceirasPage from "layouts/pages/loja/financeiro/contas-financeiras";
import LogsCobrancasPage from "layouts/pages/loja/financeiro/logs-cobrancas";

const routes = [
  {
    type: "collapse",
    name: "Estatisticas Gerais",
    key: "estatisticasEvento",
    route: "/pages/relatorios/estatisticas",
    icon: <Icon fontSize="medium">bar_chart</Icon>,
    noCollapse: true,
    private: true,
    component: <Estatisticas />,
  },
  {
    type: "collapse",
    name: "Inscrições",
    key: "inscricoes",
    route: "/pages/inscricoes",
    icon: <Icon fontSize="medium">list_alt</Icon>,
    noCollapse: true,
    private: true,
    component: <Inscricoes />,
  },
  {
    type: "collapse",
    name: "Eventos",
    key: "eventos",
    route: "/layouts/pages/cadastros/eventos",
    icon: <Icon fontSize="medium">event</Icon>,
    noCollapse: true,
    private: true,
    component: <Eventos />,
  },
  {
    type: "collapse",
    name: "Pedidos",
    key: "pedidos-acesso",
    route: "/loja/pedidos",
    icon: <Icon fontSize="medium">shopping_bag</Icon>,
    noCollapse: true,
    private: true,
    component: <LojaPedidos />,
  },
  {
    type: "collapse",
    name: "Resultados",
    key: "resultado",
    route: "/pages/resultado",
    icon: <Icon fontSize="medium">assistant_photo_outlined</Icon>,
    noCollapse: true,
    private: true,
    component: <Resultados />,
  },
  {
    type: "collapse",
    name: "Orçamento",
    key: "orcamento",
    icon: <Icon fontSize="medium">request_quote</Icon>,
    collapse: [
      {
        name: "Solicitações",
        key: "orcamento-solicitacoes",
        route: "/pages/orcamento/solicitacoes",
        private: true,
        component: <OrcamentoSolicitacoes />,
      },
      {
        name: "Serviços",
        key: "orcamento-servicos",
        route: "/pages/orcamento/servicos",
        private: true,
        component: <OrcamentoServicos />,
      },
    ],
  },
  { type: "divider", key: "divider-orcamento" },
  {
    type: "collapse",
    name: "Comunicados",
    key: "comunicados",
    route: "/pages/comunicados",
    icon: <Icon fontSize="medium">campaign</Icon>,
    noCollapse: true,
    private: true,
    component: <Comunicados />,
  },
  {
    type: "collapse",
    name: "Messenger",
    key: "messenger",
    route: "/pages/messenger",
    icon: <Icon fontSize="medium">email</Icon>,
    noCollapse: true,
    private: true,
    component: <Messenger />,
  },
  { type: "divider", key: "divider-1" },
  {
    type: "collapse",
    name: "Financeiro",
    key: "financeiro",
    icon: <Icon fontSize="medium">currency_exchange</Icon>,
    collapse: [
      {
        name: "Dashboard Financeiro",
        key: "financeiro",
        route: "/loja/financeiro",
        private: true,
        hidden: false,
        component: <LojaFinanceiro />,
      },
      {
        name: "Lançamentos de vendas",
        key: "lancamentos-vendas",
        route: "/loja/financeiro/lancamentos-vendas",
        private: true,
        hidden: false,
        component: <LojaFinanceiroLancamentosVendasPage />,
      },
      {
        name: "Por evento",
        key: "financeiro-eventos",
        route: "/financeiro/financeiro-eventos",
        icon: <Icon fontSize="medium">dashboard</Icon>,
        private: true,
        component: <Financeiro />,
      },
      {
        name: "Extrato Inscrições",
        key: "extrato",
        route: "/financeiro/extrato",
        private: true,
        component: <Extratos />,
      },
      {
        name: "Movimentação Financeira",
        key: "extrato-financeiro",
        route: "/loja/financeiro/extrato-financeiro",
        private: true,
        hidden: false,
        component: <LojaFinanceiroExtratoFinanceiroPage />,
      },
      // {
      //   name: "Conciliação financeira",
      //   key: "conciliacao-financeira",
      //   route: "/loja/financeiro/conciliacao",
      //   private: true,
      //   hidden: false,
      //   component: <LojaFinanceiroConciliacaoPage />,
      // },
      {
        name: "Definição de Taxas",
        key: "taxas",
        route: "/financeiro/taxas",
        private: true,
        component: <DefinicaoTaxas />,
      },
      {
        name: "Contas a pagar",
        key: "contas-pagar",
        route: "/loja/financeiro/contas-pagar",
        private: true,
        hidden: false,
        component: <LojaFinanceiroContasPagarPage />,
      },
      {
        name: "Contas a receber",
        key: "contas-receber",
        route: "/loja/financeiro/contas-receber",
        private: true,
        hidden: false,
        component: <LojaFinanceiroContasReceberPage />,
      },
      {
        name: "DRE gerencial",
        key: "dre-gerencial",
        route: "/loja/financeiro/dre-gerencial",
        private: true,
        hidden: false,
        component: <LojaFinanceiroDREGerencialPage />,
      },
      // {
      //   name: "Centro de custo e eventos",
      //   key: "centro-custo-eventos",
      //   route: "/loja/financeiro/centro-custo-eventos",
      //   private: true,
      //   hidden: false,
      //   component: <LojaFinanceiroCentroCustoEventosPage />,
      // },
      {
        name: "Bancos",
        key: "contas-financeiras",
        route: "/loja/financeiro/contas-financeiras",
        private: true,
        hidden: false,
        component: <LojaFinanceiroContasFinanceirasPage />,
      },
      {
        name: "Logs de Cobranças",
        key: "logs-cobrancas",
        route: "/loja/financeiro/logs-cobrancas",
        private: true,
        hidden: false,
        component: <LogsCobrancasPage />,
      },

      // {
      //   name: "Gestão cobrança Pix",
      //   key: "gestao-cobranca-pix",
      //   route: "/financeiro/gestao-cobranca-pix",
      //   private: true,
      //   component: <GestaocobrancaoPix />,
      // },
      // {
      //   name: "Gestão cobrança Boletos",
      //   key: "gestao-cobranca-boletos",
      //   route: "/financeiro/gestao-cobranca-boletos",
      //   private: true,
      //   component: <Atletas />,
      // },
    ],
  },
  {
    type: "collapse",
    name: "Cadastros",
    key: "cadastros",
    icon: <Icon fontSize="medium">add_to_queue</Icon>,
    collapse: [
      {
        name: "Novo Evento",
        key: "cadastros-eventos",
        route: "/layouts/pages/cadastros/eventos/criar",
        private: true,
        component: <NewEvento />,
      },
      {
        name: "Atletas",
        key: "atletas",
        route: "/dashboards/atletas",
        private: true,
        component: <Atletas />,
      },
      {
        name: "Modalidades",
        key: "modalidades",
        route: "pages/modalidades",
        private: true,
        component: <Modalidades />,
      },
      {
        name: "Cupons de Desconto",
        key: "cupons",
        route: "/dashboards/cupons",
        private: true,
        component: <Cupons />,
      },
      {
        name: "Organizadores",
        key: "organizadores",
        route: "/dashboards/organizadores",
        private: true,
        component: <Organizador />,
      },
      {
        name: "Patrocinadores",
        key: "patrocinadores",
        route: "/dashboards/patrocinadores",
        private: true,
        component: <Patrocinadores />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Loja Virtual",
    key: "loja-virtual",
    icon: <Icon fontSize="medium">store</Icon>,
    collapse: [
      {
        name: "Produtos",
        key: "produtos",
        route: "/loja/produtos",
        private: true,
        hidden: false,
        component: <LojaProdutos />,
      },
      {
        name: "Pedidos",
        key: "pedidos",
        route: "/loja/pedidos",
        private: true,
        hidden: false,
        component: <LojaPedidos />,
      },
      {
        name: "Estoque",
        key: "loja-estoque",
        route: "/loja/estoque",
        private: true,
        hidden: false,
        component: <LojaEstoque />,
      },
      {
        name: "Avaliações",
        key: "avaliacoes",
        route: "/loja/avaliacoes",
        private: true,
        hidden: false,
        component: <LojaAvaliacoes />,
      },
      {
        name: "Atributos",
        key: "atributos",
        route: "/loja/atributos",
        private: true,
        hidden: false,
        component: <LojaAtributos />,
      },
      {
        name: "Categorias",
        key: "categorias",
        route: "/loja/categorias",
        private: true,
        hidden: false,
        component: <LojaCategorias />,
      },
      {
        name: "Marcas",
        key: "marcas",
        route: "/loja/marcas",
        private: true,
        hidden: false,
        component: <LojaMarcas />,
      },
      {
        name: "Cupons Loja",
        key: "cupons-loja",
        route: "/loja/cupons-loja",
        private: true,
        hidden: false,
        component: <LojaCupons />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Configurações",
    key: "configuracoes",
    icon: <Icon fontSize="medium">settings</Icon>,
    collapse: [
      {
        name: "Dados da Empresa",
        key: "configuracoes",
        route: "/loja/configuracoes",
        private: true,
        hidden: false,
        component: <LojaConfig />,
      },
      {
        name: "Frete Melhor Envio",
        key: "melhor-envio",
        route: "/loja/melhor-envio",
        private: true,
        hidden: false,
        component: <ConfigMelhorEnvio />,
      },
      {
        name: "Controle de Acesso",
        key: "controle-acesso",
        route: "/configuracoes/controle-acesso",
        private: true,
        hidden: false,
        component: <ControleAcesso />,
      },
    ],
  },
];

export default routes;
